export const decimalToPercentage = (decimalValue: number): number => decimalValue * 100;
